import { createSelector } from '@reduxjs/toolkit';
import { selectAuthUser } from './authSlice';
import { selectPreparedMenuItems } from './menuSlice';
import { getRoutesBasedOnUserGroups } from '../utils/user';

export const selectAllowedRoutes = createSelector([selectAuthUser], (user) =>
    getRoutesBasedOnUserGroups(user)
);

export const selectPreparedMenuItemsCount = createSelector(
    [selectPreparedMenuItems],
    (prepared) => Object.values(prepared).flat().length
);
